import { CreatePickupPage } from "@/pages/pickup/create-pickup-page";
import { RouteType } from "../types";
import { route } from "../utils";
import PickupPage from "@/pages/pickup/pickup-page";
import { EditPickupPage } from "@/pages/pickup/edit-pickup-page";

export const pickupRoutes: Record<string, RouteType> = {
  list: route("/pickups", PickupPage),
  new: route("/pickups/new", CreatePickupPage),
  edit: route("/pickups/:id/edit", EditPickupPage),
};
